import React, { useEffect, useState } from 'react';
import Modal from '../../BaseComponents/Modal';
import Button from '../../BaseComponents/Button';
import './ReferralLetterDownloadModal.scss';

interface ReferralLetterDownloadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDownload: (downloadForGs: boolean) => Promise<void>;
}

const ReferralLetterDownloadModal: React.FC<ReferralLetterDownloadModalProps> = ({
  isOpen,
  onClose,
  onDownload,
}) => {
  const [downloadForGs, setDownloadForGs] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setDownloadForGs(true);
      setIsDownloading(false);
    }
  }, [isOpen]);

  const handleClose = () => {
    setDownloadForGs(true);
    setIsDownloading(false);
    onClose();
  };

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      await onDownload(downloadForGs);
      handleClose();
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title='Download referral letter'
      width='520px'
    >
      <div className='referral-letter-download-modal'>
        <div className='form-group'>
          <div className='radio-group'>
            <label>
              <input
                type='radio'
                name='referral_letter_download_brand'
                checked={downloadForGs}
                onChange={() => setDownloadForGs(true)}
              />
              Download for GS
            </label>
            <label>
              <input
                type='radio'
                name='referral_letter_download_brand'
                checked={!downloadForGs}
                onChange={() => setDownloadForGs(false)}
              />
              Download for CV
            </label>
          </div>
        </div>

        <div className='button-group'>
          <Button text='Download' onClick={handleDownload} isLoading={isDownloading} />
        </div>
      </div>
    </Modal>
  );
};

export default ReferralLetterDownloadModal;
